<template>
  <div class="partnership-flow">
    <component :is="getPartnerComponent()" />
  </div>
</template>

<script>
export default {
  name: 'partnership-flow',
  props: {
    partner: String
  },
  methods: {
    getPartnerComponent() {
      return `partner-${this.partner}`
    }
  }
}
</script>

<style lang="scss" scoped>
.partnership-flow {
  position: relative;
  flex-grow: 1;
  overflow: visible;
  padding: 0 4rem;

  @media screen and (min-width: 641px) {
  }
  @media screen and (min-width: 769px) {
  }
}
</style>
